/**
 * @generated SignedSource<<f2445ebfd8cfbda700cf4c96fafcc681>>
 * @relayHash d9699e98231ef8e7a3109c3783d3cfc5
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9699e98231ef8e7a3109c3783d3cfc5

import { ConcreteRequest } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Language = "ENGLISH" | "FRENCH" | "GERMAN" | "ITALIAN";
export type useTreamentByIdQuery$variables = {
  id: string;
  skip: boolean;
};
export type useTreamentByIdQuery$data = {
  readonly treatmentPlanTemplateById?: {
    readonly countries: ReadonlyArray<Country>;
    readonly icdDiagnoses: ReadonlyArray<{
      readonly diagnosisCode: string;
      readonly id: string;
      readonly text: string;
    }>;
    readonly id: string;
    readonly languages: ReadonlyArray<{
      readonly followUpInstructions: string | null;
      readonly language: Language;
      readonly recommendedTreatment: string | null;
      readonly synonym: string | null;
      readonly title: string;
    }>;
    readonly name: string;
  } | null;
};
export type useTreamentByIdQuery = {
  response: useTreamentByIdQuery$data;
  variables: useTreamentByIdQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "skip"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "condition": "skip",
    "kind": "Condition",
    "passingValue": false,
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "kind": "Variable",
            "name": "id",
            "variableName": "id"
          }
        ],
        "concreteType": "TreatmentPlanTemplate",
        "kind": "LinkedField",
        "name": "treatmentPlanTemplateById",
        "plural": false,
        "selections": [
          (v1/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "countries",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "TreatmentPlanTemplateLanguage",
            "kind": "LinkedField",
            "name": "languages",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "language",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "title",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "synonym",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "followUpInstructions",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "recommendedTreatment",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "IcdDiagnosis",
            "kind": "LinkedField",
            "name": "icdDiagnoses",
            "plural": true,
            "selections": [
              (v1/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "diagnosisCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "text",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useTreamentByIdQuery",
    "selections": (v2/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useTreamentByIdQuery",
    "selections": (v2/*:: as any*/)
  },
  "params": {
    "id": "d9699e98231ef8e7a3109c3783d3cfc5",
    "metadata": {},
    "name": "useTreamentByIdQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "2e70ef07c9f334272ddc4498d51e982f";

export default node;
